<template>
	<div class="container-sm mh-100 pt-10">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Crear empresa" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Crear" :cancelUrl="{ name: 'home' }" :submitting="submitting" :errors="validationExternal" @submit="submit">
				<template #body>
					<CommonFormInputText v-model="form.name" title="Nombre" subtitle="Obligatorio" placeholder="Ingresa tu nombre" :focus="true" :validation="validation.name" />
					<CommonFormInputSelect v-model="form.country_code" title="País" subtitle="Obligatorio" placeholder="Seleccionar el país" :options="$env.GENERAL.countries" :validation="validation.country_code" />
					<CommonFormInputImage v-model="form.avatar" :imageUrl="form?.avatar_url" title="Avatar" titleModal="Cambiar avatar" :rounded="true" @remove="removeImage" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import _ from 'lodash';
	import useVuelidate from '@vuelidate/core';
	import { helpers } from '@vuelidate/validators';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import CompanyRepository from '@/repositories/modules/Company';

	export default {
		setup() {
			const { submitting, validationExternal, catchError } = composableForm();

			const form = reactive({
				name: null,
				country_code: null,
				avatar: null,
				avatar_url: null
			});

			const validation = useVuelidate({
				name: {
					required,
					minLength: minLength(3),
					maxLength: maxLength(150)
				},
				country_code: {
					required
				}
			}, form);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				//Formatea el teléfono
				await CompanyRepository.store(form).then(async (response) => {
					await store.dispatch('auth/me').catch(catchError);
					router.push({ name: 'company.admin.setting.config', params: { company_id: response.data.id }});
				}).catch(catchError);

				submitting.value = false;
			}

			const removeImage = () => {
				form.avatar_url = null;
			}

			return { form, submit, removeImage, submitting, validation, validationExternal };
		}
	}
</script>